import { neverHere } from "../tsHelpers";

export const asArray = () => [
  Month.January,
  Month.February,
  Month.March,
  Month.April,
  Month.May,
  Month.June,
  Month.July,
  Month.August,
  Month.September,
  Month.October,
  Month.November,
  Month.December,
];

export const toFriendlyName = (type: Month) => {
  switch (type) {
    case Month.January:
      return "January";
    case Month.February:
      return "February";
    case Month.March:
      return "March";
    case Month.April:
      return "April";
    case Month.May:
      return "May";
    case Month.June:
      return "June";
    case Month.July:
      return "July";
    case Month.August:
      return "August";
    case Month.September:
      return "September";
    case Month.October:
      return "October";
    case Month.November:
      return "November";
    case Month.December:
      return "December";
    default:
      return neverHere(type);
  }
};
